import RequestCompOffAdminActionType from './RequestCompOffAdmin.types';
import { decodeHexResponse } from '../_common/common.utils';

const INITIAL_STATE: any = {
	requestCompOffAdminResponse: null,
	allEmployeesCompOffAdminResponse: null,
	holidaysCompOffAdminResponse: null,
};

const requestCompOffAdminReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_START:
			return { ...state, requestCompOffAdminResponse: null };
		case RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_SUCCESS:
			return {
				...state,
				requestCompOffAdminResponse: decodeHexResponse(
					action.payload,
					RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_KEY,
				),
			};
		case RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_FAILURE:
			return {
				...state,
				requestCompOffAdminResponse: decodeHexResponse(
					action.payload,
					RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_KEY,
				),
			};
		case RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_RESPONSE_CHANGED:
			return { ...state, requestCompOffAdminResponse: null };
		case RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_RESPONSE_REST_START:
			return { ...state, requestCompOffAdminResponse: null };
		case RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_START:
			return { ...state, allEmployeesCompOffAdminResponse: null };
		case RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_SUCCESS:
			return {
				...state,
				allEmployeesCompOffAdminResponse: decodeHexResponse(
					action.payload,
					RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_KEY,
				),
			};
		case RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_FAILURE:
			return {
				...state,
				allEmployeesCompOffAdminResponse: decodeHexResponse(
					action.payload,
					RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_KEY,
				),
			};
		case RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_RESPONSE_CHANGED:
			return { ...state, allEmployeesCompOffAdminResponse: null };
		case RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_RESPONSE_REST_START:
			return { ...state, allEmployeesCompOffAdminResponse: null };
		case RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_START:
			return { ...state, holidaysCompOffAdminResponse: null };
		case RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_SUCCESS:
			return {
				...state,
				holidaysCompOffAdminResponse: decodeHexResponse(
					action.payload,
					RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_KEY,
				),
			};
		case RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_FAILURE:
			return {
				...state,
				holidaysCompOffAdminResponse: decodeHexResponse(
					action.payload,
					RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_KEY,
				),
			};
		case RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_RESPONSE_CHANGED:
			return { ...state, holidaysCompOffAdminResponse: null };
		case RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_RESPONSE_REST_START:
			return { ...state, holidaysCompOffAdminResponse: null };
		default:
			return state;
	}
};

export default requestCompOffAdminReducer;

